// components/ProductFilters.js
import React from 'react';

const ProductFilters = ({ categories, activeCategory, onCategoryChange, sortBy, onSortChange }) => {
  return (
    <div className="mb-8 px-4">
      {/* Category Filters - Horizontal scrollable on mobile */}
      <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide mb-4">
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => onCategoryChange(category.id)}
            className={`px-4 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-300 ${
              activeCategory === category.id
                ? 'bg-red-600 text-white'
                : 'bg-gray-100 text-gray-700'
            }`}
          >
            {category.name}
          </button>
        ))}
      </div>

      {/* Sort Dropdown - More compact */}
      <div className="flex items-center justify-end gap-2">
        <span className="text-sm text-gray-600">Sort by:</span>
        <select
          value={sortBy}
          onChange={(e) => onSortChange(e.target.value)}
          className="px-2 py-1 text-sm bg-white border border-gray-300 rounded-lg"
        >
          <option value="featured">Featured</option>
          <option value="price-low">Price: Low to High</option>
          <option value="price-high">Price: High to Low</option>
          <option value="newest">Newest First</option>
        </select>
      </div>
    </div>
  );
};

export default ProductFilters;